import React from "react";
import { IconCircleFilledIcon } from "./Icon";

type CheckBoxRoundType = {
  size?: number;
  status: boolean;
  fillColor?: string;
};

export const CheckBoxRound: React.FC<CheckBoxRoundType> = ({
  size = 20,
  status = false,
  fillColor = "bgcolor-grey",
}) => {
  return status ? (
    <IconCircleFilledIcon
      size={size ?? 20}
      name="check"
      color="white"
      bgColor={fillColor === "bgcolor-grey" ? "bgcolor-primary" : fillColor}
    />
  ) : (
    <div
      className={`rounded-circle  ${fillColor}`}
      style={{ width: size, height: size }}
    ></div>
  );
};

type OffOnType = {
  name: string;
  value: boolean;
  handleOnChange?: (fieldName: string, fieldValue: string) => void;
};

export const OffOn: React.FC<OffOnType> = ({
  name = Date.now().toString(),
  value = false,
  handleOnChange = undefined,
}) => {
  let fieldName: string = "",
    fieldValue: string = "";

  const handleOnChangePush = (event: React.ChangeEvent<HTMLInputElement>) => {
    fieldName = event.target.name.toLowerCase();
    fieldValue = event.target.value.toString();

    handleOnChange?.(fieldName, fieldValue);
  };

  return (
    <input
      id={name}
      name={name}
      checked={value}
      type="checkbox"
      className="checkbox-onoff"
      onChange={(e) => handleOnChangePush(e)}
    />
  );
};
